import { Inbox } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const EmptyState = ({ title = 'Rien à afficher pour cette période', body = "Essayez d'élargir la période ou de retirer un filtre.", onClear, actionLabel = 'Effacer les filtres', className = '' }) => (
  <div className={`flex flex-col items-center justify-center rounded-2xl border border-dashed bg-muted/30 px-6 py-12 text-center ${className}`} data-testid="empty-state">
    <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl accent-bg-100">
      <Inbox className="h-6 w-6 accent-text" />
    </div>
    <p className="font-display text-sm font-semibold text-foreground">{title}</p>
    <p className="mt-1 max-w-sm text-xs text-muted-foreground">{body}</p>
    {onClear && (
      <Button variant="outline" size="sm" className="mt-4" onClick={onClear} data-testid="empty-clear-filters">
        {actionLabel}
      </Button>
    )}
  </div>
);
